<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocPreviewRessourceSansDescription'
});
</script>
<template>
  <ka-container
    code="bloc-preview-ressource-sans-description"
    :options="$merge({ click: componentInstance.blocPreviewRessourceSansDescriptionClick }, options)"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-image
      code="image"
      :options="{
        animationIn: `fadeIn`,
        lazyOptions: {
          throttle: 200,
          once: true,
          intersection: { threshold: 0.1 }
        },
        imgFit: `cover`,
        alt: `Pour assurer le bon déroulement d'une formation, un rendez-vous découverte est organisé entre l'expert et l'entreprise `
      }"
      :xs="{ defaultImage: `https://images.unsplash.com/photo-1561948955-570b270e7c36?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyOTM3MTZ8MHwxfHNlYXJjaHwxMHx8Y2F0fGVufDB8fHx8MTY5MjI2MjkwN3ww&ixlib=rb-4.0.3&q=80&w=1080` }"
      :value="componentInstance.$image.value"
      :xs-value="componentInstance.$image.value" />
    <ka-text
      code="text"
      :value="componentInstance.$title.value">
      <template #xs>
        <span v-html="componentInstance.$title.value" />
      </template>
    </ka-text>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocPreviewRessourceSansDescriptionComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c38')
const component = blocPreviewRessourceSansDescriptionComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  title?: Nullable<string>
  image?: Nullable<string | File>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  title: '<strong>Bien préparer mon rendez-vous découverte</strong>',
  image: 'https://ucarecdn.com/faa1f66e-8744-4520-a00a-5e620aaeafb2/',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:title',
  'update:image'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    title: true,
    image: true
  }
})
</script>
